exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#multislider[data-v-7f5af85d]{background-color:transparent}b-button[data-v-7f5af85d]{margin-left:1rem}b-button[data-v-7f5af85d]:first-of-type{margin-left:none}", ""]);

// exports
